'use strict';

import angular from 'angular';

/**
 * Configuration des routes pour les autorisations de recherche
 */
export default angular.module('observatoireApp')
  .config(['$stateProvider', function($stateProvider) {
    $stateProvider
      .state('main.autorisations-recherche', {
        url: '/autorisations-recherche',
        templateUrl: 'app/autorisations-recherche/autorisations-recherche.html',
        controller: 'AutorisationsRechercheController'
      });
  }]);
